import React, { useEffect, useState, useRef } from "react";
import TextfieldInput from "../../Shared/TextField";
import DateSelectionFuture from "../../Shared/DateSelection/DateSelectionFuture";
import TableDragResources from "../../Shared/Tables/TableDragResources";
import DescriptionItem from "../../Shared/DescriptionItem";
import DropdownCompany from "../../Shared/Dropdowns/DropdownCopmany";
import DropdownResources from "../../Shared/Dropdowns/DropdownResources";
import ButtonNormalText from "../../Shared/Buttons/ButtonNormalText";
import ButtonNormalDelete from "../../Shared/Buttons/ButtonNormalDelete";
import Select from "../../Shared/Select/Select";
import SelectTrigger from "../../Shared/Select/SelectTrigger";
import SelectContent from "../../Shared/Select/SelectContent";
import SelectItem from "../../Shared/Select/SelectItem";
import ShareDialog from "../../Shared/Dialogs/ShareDialog";
import ChangeHistoricalPriceDialog from "./Components/ChangeHistoricalPriceDialog";
import BulkUpdatePriceBundleDialog from "./Components/BulkUpdatePriceBundleDialog";

import { dataService } from "../../../Services/data/data.service";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import { Spin } from "react-cssfx-loading";

import { Grid2, Divider, DialogTitle, DialogContentText, DialogContent, DialogActions, Dialog, Box, Tooltip } from "@mui/material";
import { Trash2, Save, CircleHelp, Settings, Eye, Copy, QrCode } from "lucide-react";
import Breadcrumb from "../../Shared/Header/Breadcrumb";
import HeaderBar from "../../Shared/Header/HeaderBar";
import HeaderEnd from "../../Shared/Header/HeaderEnd";
import HeaderTitle from "../../Shared/Header/HeaderTitle";
import BoolToggle from "../../Shared/Buttons/BoolToggle";

toast.configure();

function ModifyPage(props) {
  const navigate = useNavigate();
  const { projectQr } = useParams();

  const [FromDate, setFromDate] = useState(new Date());
  const [ToDate, setToDate] = useState(new Date());
  const [projectQR, setProjectQR] = useState(null);

  // Project properties
  const [projectId, setProjectId] = useState(null);
  const [projectName, setProjectName] = useState("");
  const [resourceName, setResourceName] = useState("");
  const [selectedResource, setSelectedResource] = useState("");
  const [projectHasMeasurements, setProjectHasMeasurements] = useState(false);

  const [CompanyName, setCompanyName] = useState("");
  const [CompanyId, setCompanyId] = useState(null);
  const [OldCompanyId, setOldCompanyId] = useState(null);
  const [projectDetailRows, setProjectDetailRows] = useState([]);
  const [originalProjectDetailRows, setOriginalProjectDetailRows] = useState([]); // Copy to check if changes are made

  // General properties
  const [allCompanies, setAllCompanies] = useState([]);
  const [resources, setResources] = useState([]);
  const [currentSaveType, setCurrentSaveType] = useState(null);

  const [delopen, setDelOpen] = useState(false);
  const GetUserId = props.Login.userid;
  const [openQr, setOpenQr] = useState(false);

  // TableDragResources
  const tableDragResourcesRef = useRef();

  const [historicalPriceChangeDialogOpen, setHistoricalPriceChangeDialogOpen] = useState(false);
  const [bulkUpdateDialogOpen, setBulkUpdateDialogOpen] = useState(false);

  const classes = useStyles();
  const [types, setTypes] = useState([]);
  const [activeProject, setActiveProject] = useState(true);
  const [singleStopwatch, setSingleStopwatch] = useState(false);
  const [helperTextProjectName, setHelperTextProjectName] = useState(null);
  const [helperTextCompany, setHelperTextCompany] = useState(null);
  const [helperTextResourceDescription, setHelperTextResourceDescription] = useState(null);
  const [errorProjectName, setErrorProjectName] = useState(false);
  const [errorCompany, setErrorCompany] = useState(false);
  const [errorResourceDescription, setErrorResourceDescription] = useState(false);
  const [emptyDetails, setEmptyDetails] = useState(false);
  const [loading, setLoading] = useState(true);

  const [allCurrencies, setAllCurrencies] = useState([]);
  const [allPriceBundles, setAllPriceBundles] = useState([]);
  const [activeCurrency, setActiveCurrency] = useState({ symbol: "€" });

  const [generalError, setGeneralError] = useState(null);
  const [selectedProjectOption, setSelectedProjectOption] = useState("");

  useEffect(() => {
    if (allCurrencies.length > 0 && CompanyId !== null) {
      let selectedCompany = allCompanies.find((x) => x.id === CompanyId);
      if (selectedCompany) {
        let currency = allCurrencies.find((x) => x.id === selectedCompany.currencyId);
        if (currency !== undefined) {
          setActiveCurrency(currency);
        }
      }
    }
  }, [CompanyId, allCurrencies]);

  useEffect(() => {
    const fetchData = async () => {
      if (projectQr !== null) {
        setProjectQR(projectQr);
      }

      let project;
      let tempProjectDetailRows = [];

      try {
        const results = await Promise.all([
          dataService.getAllCompaniesByUserId(props.Login.userid),
          dataService.getResources(props.Login.userid),
          dataService.getTypes(),
          dataService.getProjectByQr(projectQr),
          dataService.getProjectDetailsByQr(projectQr),
          dataService.projectHasMeasurements(projectQr),
          dataService.getAllCurrencies(),
          dataService.getAllPriceBundles(props.Login.userid),
        ]);

        // Destructure results
        const [companyResults, resourcesResults, typeResults, projectResults, projectDetailsResults, projectHasMeasurementsResult, allCurrencies, allPriceBundlesResults] = results;

        setProjectHasMeasurements(projectHasMeasurementsResult);
        setAllCompanies(companyResults);
        setResources(resourcesResults);
        setAllCurrencies(allCurrencies);
        setAllPriceBundles(allPriceBundlesResults || []);

        if (typeResults !== null) {
          setTypes(typeResults.sort((a, b) => a.description.localeCompare(b.description)));
        }

        project = projectResults ?? null;

        if (projectDetailsResults !== null && projectDetailsResults.some((x) => x.id)) {
          tempProjectDetailRows = await Promise.all(
            projectDetailsResults.map(async (x) => ({
              comment: x.hasComment,
              isParent: x.isParent,
              isApiParent: x.isApiParent,
              color: x.color,
              typeId: x.typeId,
              type: x.typeId,
              description: x.description,
              Id: x.id,
              edit: false,
              accountId: x.accountId,
              sequence: x.sequence,
              dataListId: x.dataListId,
              externalApiId: x.externalApiId,
              price: x.price,
              isProfit: x.isProfit,
              costProfit: x.isProfit ? "+" : "-",
              valueTypeId: x.valueTypeId,
              priceBundleId: x.priceBundleId,
              sessionDurationMinutes: x.sessionDurationMinutes,
              descriptionError: null,
              accountError: null,
              typeError: null,
              hasMeasurements: await detailHasMeasurements(x.id),
            }))
          );
        }
      } catch (error) {
        toast.error("Something went wrong while fetching the data.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        console.error("Error: ", error);
      } finally {
        if (project !== null) {
          setProjectId(project.id);
          setProjectName(project.projectName);
          setCompanyName(project.companyName);
          setOldCompanyId(project.companyId);
          setCompanyId(project.companyId);
          setResourceName(project.resourceDescription);
          setSingleStopwatch(project.isSingleStopwatch || false);

          const fromDateString = project.timeRangeBegin ? Date.parse(project.timeRangeBegin) : Date.now();
          const toDateString = project.timeRangeEnd ? Date.parse(project.timeRangeEnd) : Date.now();

          const fromDateObject = new Date(fromDateString);
          const toDateObject = new Date(toDateString);

          setFromDate(fromDateObject);
          setToDate(toDateObject);

          const currentDate = new Date();
          const difference = dateRange(fromDateObject, toDateObject, currentDate, currentDate);
          setActiveProject(!!difference);
        }

        if (tempProjectDetailRows.length > 0) {
          tempProjectDetailRows = tempProjectDetailRows.sort((a, b) => a.sequence - b.sequence);
        }

        setProjectDetailRows(tempProjectDetailRows);
        setOriginalProjectDetailRows(tempProjectDetailRows);
        setLoading(false);
      }
    };

    fetchData();
  }, [projectQr, props.Login.userid]); // eslint-disable-line react-hooks/exhaustive-deps

  const detailHasMeasurements = async (detailId) => {
    const hasMeasurements = await dataService.projectDetailHasMeasurements(detailId);
    return hasMeasurements;
  };

  const refreshProjectDetails = async () => {
    try {
      const projectDetailsResults = await dataService.getProjectDetailsByQr(projectQr);
      if (projectDetailsResults !== null && projectDetailsResults.some((x) => x.id)) {
        let tempProjectDetailRows = await Promise.all(
          projectDetailsResults.map(async (x) => ({
            comment: x.hasComment,
            isParent: x.isParent,
            isApiParent: x.isApiParent,
            color: x.color,
            typeId: x.typeId,
            type: x.typeId,
            description: x.description,
            Id: x.id,
            edit: false,
            accountId: x.accountId,
            sequence: x.sequence,
            dataListId: x.dataListId,
            externalApiId: x.externalApiId,
            price: x.price,
            isProfit: x.isProfit,
            costProfit: x.isProfit ? "+" : "-",
            valueTypeId: x.valueTypeId,
            priceBundleId: x.priceBundleId,
            sessionDurationMinutes: x.sessionDurationMinutes,
            descriptionError: null,
            accountError: null,
            typeError: null,
            hasMeasurements: await detailHasMeasurements(x.id),
          }))
        );
        tempProjectDetailRows = tempProjectDetailRows.sort((a, b) => a.sequence - b.sequence);
        setProjectDetailRows(tempProjectDetailRows);
        setOriginalProjectDetailRows(tempProjectDetailRows);
      }
    } catch (error) {
      console.error("Error refreshing project details:", error);
    }
  };

  const datesAreOnSameDay = (first, second) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();

  function dateRange(a_start, a_end, b_start, b_end) {
    if (a_start <= b_start && b_start <= a_end) return true; // b starts in a
    if (a_start <= b_end && b_end <= a_end) return true; // b ends in a
    if (b_start < a_start && a_end < b_end) return true; // a in b
    // if (b_start <  a_start && a_end   >  b_end) return true; // a overlaps b

    if (datesAreOnSameDay(a_start, b_start)) return true;
    if (datesAreOnSameDay(b_end, a_end)) return true;
    return false;
  }

  const setProject = (event) => {
    setProjectName(event.target.value);
  };
  const setTheFromDate = (event) => {
    if (event !== FromDate) {
      setFromDate(event);
    }
  };
  const setTheToDate = (event) => {
    if (event !== ToDate) {
      setToDate(event);
    }
  };

  const handleClickOpenQr = () => {
    setOpenQr(true);
  };
  const handleCloseQr = () => {
    setOpenQr(false);
  };

  const handleSingleStopwatchChange = async (newValue) => {
    setSingleStopwatch(newValue);
    try {
      await dataService.updateProjectSingleStopwatch(projectQr, newValue);
      toast.success("Single stopwatch setting updated", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
    } catch (error) {
      // Revert on error
      setSingleStopwatch(!newValue);
      toast.error("Failed to update single stopwatch setting", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      console.error("Error updating single stopwatch:", error);
    }
  };

  const handleDialogOpenDel = () => {
    setDelOpen(true);
  };
  const handleDialogCloseDel = () => {
    setDelOpen(false);
  };
  
  const handleProjectOptionChange = (value) => {
    setSelectedProjectOption(value);
    // Execute the corresponding action based on the selected option
    switch (value) {
      case "view-results":
        resultsRedirect();
        break;
      case "duplicate":
        duplicateRedirect();
        break;
      case "bulk-update":
        handleBulkUpdateOpen();
        break;
      case "qr-code":
        handleClickOpenQr();
        break;
      case "delete":
        handleDialogOpenDel();
        break;
      default:
        break;
    }
    // Reset the select after action
    setSelectedProjectOption("");
  };
  const setCompany = (event) => {
    if (projectDetailRows.length > 0) {
      let tempProjectDetailRows = projectDetailRows.map((row) => ({
        ...row,
        edit: true,
        accountId: null,
      }));

      setProjectDetailRows(tempProjectDetailRows);
    }
    if (event.inputValue) {
      if (allCompanies.some((x) => x.name === event.inputValue)) {
        setCompanyId(allCompanies.find((x) => x.name === event.inputValue).id);
        setCompanyName(event.inputValue);
      }
    } else {
      if (event.target.textContent) {
        if (allCompanies.some((x) => x.name === event.target.textContent)) {
          setCompanyId(allCompanies.find((x) => x.name === event.target.textContent).id);
          setCompanyName(event.target.textContent);
        }
      } else {
        if (allCompanies.some((x) => x.name === event.target.value)) {
          setCompanyId(allCompanies.find((x) => x.name === event.target.value).id);
        }
        setCompanyName(event.target.value);
      }
    }
  };

  const setDates = (fromDate, toDate) => {
    setFromDate(fromDate);
    setToDate(toDate);
    let tempFromDate = fromDate;
    let tempToDate = toDate;
    props.actions.fromDateAction(tempFromDate);
    props.actions.toDateAction(tempToDate);
  };

  const checkForPriceChanges = async (detailId) => {
    let priceChanges = false;

    if (detailId) {
      const originalRow = originalProjectDetailRows.find((x) => x.Id === detailId);
      const row = projectDetailRows.find((x) => x.Id === detailId);

      if (originalRow && parseFloat(originalRow.price) !== parseFloat(row.price)) {
        const hasMeasurements = await dataService.projectDetailHasMeasurements(row.Id);
        if (hasMeasurements) {
          priceChanges = true;
        }
      }
    } else {
      for (const row of projectDetailRows) {
        const originalRow = originalProjectDetailRows.find((x) => x.Id === row.Id);
        if (originalRow && parseFloat(originalRow.price) !== parseFloat(row.price)) {
          const hasMeasurements = await dataService.projectDetailHasMeasurements(row.Id);
          if (hasMeasurements) {
            priceChanges = true;
            break; // Stop checking once a change is detected
          }
        }
      }
    }

    return priceChanges;
  };

  const save = async (newProjectrows, changeHistoricalPrice) => {
    setGeneralError(null);
    setHistoricalPriceChangeDialogOpen(false);
    setCurrentSaveType("row");
    if (projectName === "" || resourceName === "" || CompanyId === "" || CompanyName === "" || FromDate === "" || ToDate === "" || resourceName === null || FromDate === null || ToDate === null) {
      if (projectName === "") {
        setHelperTextProjectName("Please enter a project name.");
        setErrorProjectName(true);
      } else {
        setHelperTextProjectName(null);
        setErrorProjectName(false);
      }
      if (resourceName === "" || resourceName === null || resourceName === undefined) {
        setHelperTextResourceDescription("Please select or enter a registration point.");
        setErrorResourceDescription(true);
      } else {
        setHelperTextResourceDescription(null);
        setErrorResourceDescription(false);
      }
      if (CompanyId === "" || CompanyId === null || CompanyName === "" || CompanyName === null || CompanyName === undefined) {
        setHelperTextCompany("Please select or create a Company.");
        setErrorCompany(true);
      } else {
        setHelperTextCompany(null);
        setErrorCompany(false);
      }
    } else {
      if ((await checkForPriceChanges()) && (changeHistoricalPrice === null || changeHistoricalPrice === undefined)) {
        setHistoricalPriceChangeDialogOpen(true);
      } else {
        setHelperTextResourceDescription(null);
        setErrorResourceDescription(false);
        setHelperTextCompany(null);
        setErrorCompany(false);
        setHelperTextProjectName(null);
        setErrorProjectName(false);
        setEmptyDetails(false);
        if (newProjectrows.length === 0) {
          setEmptyDetails(true);
        } else {
          setEmptyDetails(false);
          let def = await Promise.all(
            newProjectrows
              .map(async (x) => ({
                HasComment: x.comment,
                IsParent: x.isParent,
                IsApiParent: x.isApiParent,
                color: x.color,
                description: x.description,
                typeId: x.type,
                type: x.type,
                Id: x.Id,
                projectId: projectId,
                sequence: x.sequence,
                dataListId: x.dataListId,
                externalApiId: x.externalApiId,
                price: x.price === "" || x.price === undefined || x.price === null ? 0 : parseFloat(String(x.price).replace(",", ".")),
                isProfit: x.isProfit,
                costProfit: x.isProfit ? "+" : "-",
                valueTypeId: x.valueTypeId,
                accountId: x.accountId,
                priceBundleId: x.priceBundleId,
                sessionDurationMinutes: x.sessionDurationMinutes || null,
                newRow: x.newRow,
                historicalPriceChange: (await checkForPriceChanges(x.Id)) ? changeHistoricalPrice : false,
              }))
              .sort((a, b) => a.sequence - b.sequence)
          );
          def.forEach((detail, index) => {
            detail.sequence = index + 1;
          });

          var resourceId = 0;
          if (selectedResource !== null && selectedResource !== undefined) {
            resourceId = selectedResource.id;
          }

          dataService
            .updateProjects(GetUserId, projectName, resourceName, resourceId, OldCompanyId, CompanyId, CompanyName, FromDate, ToDate, def, projectId, projectQr, singleStopwatch)
            .then(async (response) => {
              if (!response) {
                toast.error("Something went wrong.", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                resetProject();
              }
              setCurrentSaveType(null);
              await refreshProjectDetails();
            })
            .catch((error) => {
              if (error.status === 403) {
                setGeneralError("You do not have an active subscription. Please contact your administrator.");
                resetProject();
              } else {
                setGeneralError("Something went wrong. Please try again.");
              }
            });
        }
      }
    }
  };

  const setResource = (event) => {
    if (event !== null && event.value !== undefined && resources.some((x) => x.id === event.value)) {
      var selectedResourceElement = resources.find((x) => x.id === event.value);
      setResourceName(selectedResourceElement.name);
      setSelectedResource(selectedResourceElement);
    } else if (event !== null && event !== undefined && event.target !== undefined && event.target !== null && event.target.value !== undefined) {
      setResourceName(event.target.value);
      setSelectedResource(null);
    } else {
      setSelectedResource(null);
      setResourceName("");
    }
  };

  const resultsRedirect = () => {
    navigate(`/results/${projectQr}`);
  };
  const financialDashboardRedirect = () => {
    navigate(`/projectreport/${projectQr}`);
  };

  const duplicateRedirect = () => {
    navigate(`/duplicate/${projectQr}`);
  };

  const saveAllProjectDetailRows = () => {
    let invalidRowsCount = 0;
    let tempProjectDetailRows = [...projectDetailRows];

    tempProjectDetailRows.forEach((detail) => {
      if (detail.description === "" || detail.type === null) {
        invalidRowsCount++;
      }
      // if detail.price is not null and bigger then 0 detail.accountId should be set
      if (detail.price !== null && detail.price > 0 && detail.accountId === null) {
        invalidRowsCount++;
      }
    });

    if (invalidRowsCount == 0) {
      tempProjectDetailRows = tempProjectDetailRows.map((detail) => ({
        ...detail, // Spread the existing properties
        edit: false, // Override the 'edit' property
      }));

      setProjectDetailRows(tempProjectDetailRows);
      setOriginalProjectDetailRows(tempProjectDetailRows);
      return true;
    } else {
      return false;
    }
  };

  const validateRows = async () => {
    if (tableDragResourcesRef.current) {
      try {
        const valid = await tableDragResourcesRef.current.validateAllRows();
        return valid;
      } catch (error) {
        return false; // Or handle as needed
      }
    }
  };

  const sendToApi = async (changeHistoricalPrice) => {
    setGeneralError(null);
    setCurrentSaveType("project");
    setHistoricalPriceChangeDialogOpen(false);
    if (
      projectName === "" ||
      resourceName === "" ||
      CompanyId === "" ||
      CompanyName === "" ||
      FromDate === "" ||
      ToDate === "" ||
      resourceName === null ||
      FromDate === null ||
      ToDate === null ||
      !(await validateRows())
    ) {
      if (projectName === "") {
        setHelperTextProjectName("Please enter a project name.");
        setErrorProjectName(true);
      } else {
        setHelperTextProjectName(null);
        setErrorProjectName(false);
      }
      if (resourceName === "" || resourceName === null || resourceName === undefined) {
        setHelperTextResourceDescription("Please select or enter a registration point.");
        setErrorResourceDescription(true);
      } else {
        setHelperTextResourceDescription(null);
        setErrorResourceDescription(false);
      }
      if (CompanyId === "" || CompanyId === null || CompanyName === "" || CompanyName === null || CompanyName === undefined) {
        setHelperTextCompany("Please select or create a company.");
        setErrorCompany(true);
      } else {
        setHelperTextCompany(null);
        setErrorCompany(false);
      }
    } else {
      if ((await checkForPriceChanges()) && (changeHistoricalPrice === null || changeHistoricalPrice === undefined)) {
        setHistoricalPriceChangeDialogOpen(true);
      } else {
        setHelperTextResourceDescription(null);
        setErrorResourceDescription(false);
        setHelperTextCompany(null);
        setErrorCompany(false);
        setHelperTextProjectName(null);
        setErrorProjectName(false);
        setEmptyDetails(false);
        if (projectDetailRows.length === 0 || projectDetailRows.find((x) => x.type === null) !== undefined) {
          setEmptyDetails(true);
        } else {
          setEmptyDetails(false);
          if (saveAllProjectDetailRows()) {
            let tempProjDetails = [...projectDetailRows];
            tempProjDetails.sort((a, b) => b.sequence + a.sequence);
            let projectDetails = await Promise.all(
              tempProjDetails
                .map(async (x) => ({
                  HasComment: x.comment,
                  IsParent: x.isParent,
                  IsApiParent: x.isApiParent,
                  color: x.color,
                  description: x.description,
                  typeId: x.type,
                  type: x.type,
                  Id: x.Id,
                  projectId: projectId,
                  accountId: x.accountId,
                  sequence: x.sequence,
                  dataListId: x.dataListId,
                  price: x.price === "" || x.price === undefined || x.price === null ? 0 : parseFloat(String(x.price).replace(",", ".")),
                  isProfit: x.isProfit,
                  costProfit: x.isProfit !== null ? (x.isProfit ? "+" : "-") : "-",
                  valueTypeId: x.valueTypeId,
                  priceBundleId: x.priceBundleId,
                  externalApiId: x.externalApiId,
                  sessionDurationMinutes: x.sessionDurationMinutes || null,
                  newRow: x.newRow,
                  historicalPriceChange: (await checkForPriceChanges(x.Id)) ? changeHistoricalPrice : false,
                }))
                .sort((a, b) => a.sequence - b.sequence)
            );
            props.actions.toDateAction(ToDate);
            var resourceId = 0;
            if (selectedResource !== null && selectedResource !== undefined) {
              resourceId = selectedResource.id;
            }

            dataService
              .updateProjects(GetUserId, projectName, resourceName, resourceId, OldCompanyId, CompanyId, CompanyName, FromDate, ToDate, projectDetails, projectId, projectQr, singleStopwatch)
              .then(async (response) => {
                if (response && response.success) {
                  setCurrentSaveType(null);
                  toast.success("Project was saved successfully", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                  await refreshProjectDetails();
                } else {
                  toast.error("Something went wrong.", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                  resetProject();
                }
              })
              .catch((error) => {
                if (error.status === 403) {
                  setGeneralError("You do not have an active subscription. Please contact your administrator.");
                  resetProject();
                } else {
                  setGeneralError("Something went wrong. Please try again.");
                }
              });
          } else {
            if (tableDragResourcesRef.current) {
              tableDragResourcesRef.current.validateAllRows();
            }
            toast.error("Make sure all details are filled in.", { position: toast.POSITION.TOP_CENTER });
          }
        }
      }
    }
  };

  const resetProject = () => {
    var project;
    let tempProjectDetailRows = [];

    Promise.all([dataService.getProjectByQr(projectQr), dataService.getProjectDetailsByQr(projectQr)])
      .then((results) => {
        //Set result-variables
        var projectResults = results[0];
        var projectDetailsResults = results[1];

        if (projectResults !== null) {
          project = projectResults;
        } else {
          project = null;
        }

        if (projectDetailsResults !== null) {
          if (projectDetailsResults.some((x) => x.id)) {
            tempProjectDetailRows = projectDetailsResults.map((x) => ({
              comment: x.hasComment,
              isParent: x.isParent,
              isApiParent: x.isApiParent,
              color: x.color,
              typeId: x.typeId,
              type: x.typeId,
              description: x.description,
              Id: x.id,
              edit: false,
              accountId: x.accountId,
              sequence: x.sequence,
              dataListId: x.dataListId,
              externalApiId: x.externalApiId,
              price: x.price,
              isProfit: x.isProfit,
              costProfit: x.isProfit ? "+" : "-",
              valueTypeId: x.valueTypeId,
              descriptionError: null,
              accountError: null,
              typeError: null,
            }));
          }
        }
      })
      .catch((error) => {
        toast.error("Something went wrong while fetching the data.", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        console.log("Error: ", error);
      })
      .finally(() => {
        if (project !== null) {
          setProjectId(project.id);
          setProjectName(project.projectName);
          setCompanyName(project.companyName);
          setOldCompanyId(project.companyId);
          setCompanyId(project.companyId);
          setResourceName(project.resourceDescription);

          let fromDateString = "";
          if (project.timeRangeBegin !== null) {
            fromDateString = Date.parse(project.timeRangeBegin);
          } else {
            fromDateString = Date.parse();
          }
          let fromDateObject = new Date(fromDateString);
          setFromDate(fromDateObject);
          let toDateString = "";
          if (project.timeRangeEnd !== null) {
            toDateString = Date.parse(project.timeRangeEnd);
          } else {
            toDateString = Date.parse();
          }
          let toDateObject = new Date(toDateString);
          setToDate(toDateObject);

          let currentDate = new Date();
          let difference = dateRange(fromDateObject, toDateObject, currentDate, currentDate);
          if (difference) {
            setActiveProject(true);
          } else {
            setActiveProject(false);
          }
        }
        if (tempProjectDetailRows !== undefined && tempProjectDetailRows !== null) {
          tempProjectDetailRows = tempProjectDetailRows.sort((a, b) => a.sequence - b.sequence);
        }
        setProjectDetailRows(tempProjectDetailRows);
        setOriginalProjectDetailRows(tempProjectDetailRows);
        setLoading(false);
      });
  };

  const handleDeleteProject = () => {
    dataService.deleteProject(projectId, GetUserId).then((response) => {
      if (response.success) {
        toast.success("Project was deleted successfully", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      } else {
        toast.error("Something went wrong.", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      }
      navigate("/projectreportoverview");
    });
  };

  const cancelPriceChange = () => {
    setHistoricalPriceChangeDialogOpen(false);
    setProjectDetailRows(originalProjectDetailRows);
  };

  const handlePriceChangeSave = (newProjectDetailRows, historicalPriceChange) => {
    if (currentSaveType === "row") {
      save(newProjectDetailRows, historicalPriceChange);
    } else if (currentSaveType === "project") {
      sendToApi(historicalPriceChange);
    }
  };

  const handleBulkUpdateOpen = () => {
    setBulkUpdateDialogOpen(true);
  };

  const handleBulkUpdateClose = () => {
    setBulkUpdateDialogOpen(false);
  };

  const handleBulkUpdateSuccess = () => {
    // Optionally refresh project details or show success message
    // The dialog itself shows the success toast
  };

  return (
    <React.Fragment>
      {loading && (
        <div className={classes.loadingChart}>
          <Spin width="100px" height="100px" color="var(--color-primary)"></Spin>
        </div>
      )}
      <Box className="page-container">
        {/* <Box sx={{ paddingBottom: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <Typography variant='h5'>Modify your project</Typography>
                    <CustomizedMenus isActive={activeProject} handleDialogOpenDel={handleDialogOpenDel} handleClickOpenQr={handleClickOpenQr} duplicateRedirect={duplicateRedirect} resultsRedirect={resultsRedirect} financialDashboardRedirect={financialDashboardRedirect}></CustomizedMenus>
                </Box> */}
        <HeaderBar>
          <Breadcrumb onClick={() => navigate("/projectreportoverview")}>Projects</Breadcrumb>
          <HeaderTitle>Modify your project</HeaderTitle>
          <HeaderEnd>
            <Select 
              value={selectedProjectOption} 
              onChange={handleProjectOptionChange}
              placeholder="Project options"
              size="medium"
            >
              <SelectTrigger style={{
                backgroundColor: 'var(--color-primary)',
                border: 'none',
                color: '#F8F8F8'
              }}>
                Project options
              </SelectTrigger>
              <SelectContent align="right">
                <SelectItem value="view-results">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Eye size={16} />
                    View Results
                  </div>
                </SelectItem>
                <SelectItem value="duplicate">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Copy size={16} />
                    Duplicate
                  </div>
                </SelectItem>
                <SelectItem value="bulk-update">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Settings size={16} />
                    Bulk Update Price Bundles
                  </div>
                </SelectItem>
                {activeProject && (
                  <SelectItem value="qr-code">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <QrCode size={16} />
                      QR-code
                    </div>
                  </SelectItem>
                )}
                <SelectItem value="delete" variant="danger">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Trash2 size={16} />
                    Delete
                  </div>
                </SelectItem>
              </SelectContent>
            </Select>
          </HeaderEnd>
        </HeaderBar>

        <Box className={classes.container}>
          {generalError && (
            <div className={classes.errorContainer}>
              <p className={classes.errorMessage}>{generalError}</p>
            </div>
          )}
          <div className={classes.optionContainer}>
            <div className={classes.projectOptions}>
              <div className={classes.projectOption}>
                <label className={classes.labelContainer__label}>Project name</label>
                <TextfieldInput
                  label={projectName ? " " : "Project"}
                  InputLabelProps={{ shrink: false }}
                  value={projectName}
                  action={setProject}
                  helperText={helperTextProjectName}
                  error={errorProjectName}
                />
              </div>
              <div className={classes.projectOption}>
                <label className={classes.labelContainer__label}>Company name</label>
                <DropdownCompany companies={allCompanies} value={CompanyName} action={setCompany} helperText={helperTextCompany} disabled={projectHasMeasurements} error={errorCompany} />
              </div>
              <div className={classes.projectOption}>
                <div className={classes.projectOption__labelContainer}>
                  <label className={classes.labelContainer__label}>Registration point</label>
                  <Tooltip disableInteractive title="A registration point could be 'Welding machine 1'. It describes the location where you are taking measurements">
                    <CircleHelp className={classes.labelContainer__help} />
                  </Tooltip>
                </div>
                <DropdownResources resources={resources} value={resourceName} action={setResource} helperText={helperTextResourceDescription} error={errorResourceDescription} />
              </div>
            </div>
          </div>

          <Grid2 item xs={12} style={{ marginBottom: "-1rem" }}>
            <DescriptionItem Text="Active between:" />
            <DateSelectionFuture FromDate={FromDate} ToDate={ToDate} setDates={setDates} setTheFromDate={setTheFromDate} setTheToDate={setTheToDate} />
            <Divider style={{ marginBottom: "2rem", marginTop: "1rem" }}></Divider>
          </Grid2>
          {/* Setting row */}
          <div className={classes.projectSettingsRow}>
              <BoolToggle
                label="Single stopwatch"
                size="large"
                tooltipText="When toggled on, this project will only allow 1 running stopwatch at a time. Starting a new stopwatch will stop any other running stopwatches. (Beware, when using stopwatches in multiple projects, the stopwatch will be stopped for all projects.)"
                boolValue={singleStopwatch}
                onChange={handleSingleStopwatchChange}
              />
          </div>

          {emptyDetails ? (
            <div>
              <Grid2 item xs={12} sm={12} md={12} style={{ border: "solid 2px", borderColor: "#d32f2f", borderRadius: "17px" }}>
                <TableDragResources create={false} {...props} types={types} currency={activeCurrency} rows={projectDetailRows} setRows={setProjectDetailRows} companyId={CompanyId} makeSave={save} />
              </Grid2>
              <p style={{ color: "#d32f2f", fontWeight: "400", fontSize: "0.75rem", fontFamily: "Roboto, Helvetica, Arial", letterSpacing: "0.03333em" }}>Please create at least one item.</p>
            </div>
          ) : (
            <div>
              <Grid2 item xs={12} sm={12} md={12}>
                <TableDragResources
                  ref={tableDragResourcesRef}
                  create={false}
                  {...props}
                  types={types}
                  currency={activeCurrency}
                  rows={projectDetailRows}
                  setRows={setProjectDetailRows}
                  companyId={CompanyId}
                  makeSave={save}
                />
              </Grid2>
            </div>
          )}
          <div className={classes.buttonDiv} style={{ marginTop: "15px" }}>
            {/* <Button size='large' className={classes.qrButton} onClick={sendToQr}  disabled variant="contained">Generate QR</Button> */}
            {/* <ButtonSave startIcon={<Save />} content="Save" onClick={sendToApi} /> */}
            <button className={classes.primaryIconButton} onClick={() => sendToApi()}>
              <Save className={classes.iconButton__icon} absoluteStrokeWidth />
              Save
            </button>
          </div>
        </Box>
      </Box>

      {openQr && <ShareDialog openQr={openQr} handleCloseQr={handleCloseQr} projectQR={projectQR} projectName={projectName} resourceName={resourceName}></ShareDialog>}

      <ChangeHistoricalPriceDialog
        dialogOpen={historicalPriceChangeDialogOpen}
        closeDialog={() => cancelPriceChange()}
        newProjectDetailRows={projectDetailRows}
        originalProjectDetailRows={originalProjectDetailRows}
        currency={activeCurrency}
        save={handlePriceChangeSave}
      ></ChangeHistoricalPriceDialog>

      <BulkUpdatePriceBundleDialog
        dialogOpen={bulkUpdateDialogOpen}
        closeDialog={handleBulkUpdateClose}
        projectDetailRows={projectDetailRows}
        allPriceBundles={allPriceBundles}
        currency={activeCurrency}
        userId={GetUserId}
        onSuccess={handleBulkUpdateSuccess}
      />

      {delopen && (
        <Dialog open={delopen} onClose={handleDialogCloseDel} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{"Delete Project"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{"Are you sure you want to delete project " + projectName + " ?"}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <ButtonNormalText content="Close" onClick={handleDialogCloseDel}>
              Close
            </ButtonNormalText>
            <ButtonNormalDelete startIcon={<Trash2 />} content="Delete" onClick={handleDeleteProject}>
              Delete
            </ButtonNormalDelete>
          </DialogActions>
        </Dialog>
      )}
    </React.Fragment>
  );
}

export default ModifyPage;

const useStyles = makeStyles((theme) => ({
  loadingChart: {
    height: "100vh",
    width: "100%",
    top: "0px",
    position: "fixed",
    zIndex: "999",
    borderRadius: "8px",
    backgroundColor: "rgba(156,156,156,0.5)",
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  },

  container: {
    boxSizing: "border-box",
    position: "relative",
    background: "#FFFFFF",
    borderRadius: "8px",
    padding: "1.5rem",
    maxWidth: "100%",
    marginBottom: "24px",
  },

  header: {
    width: "100%",
    minHeight: "40px",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    flexWrap: "wrap",

    marginBottom: "16px",
  },

  buttonDiv: {
    marginTop: "15px",
    float: "right",
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  buttonRow: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
    marginBottom: "10px",
  },
  optionContainer: {
    marginBottom: "24px",
    display: "flex",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  projectOptions: {
    display: "flex",
    gap: "16px",
    [theme.breakpoints.up("sm")]: {
      flexWrap: "nowrap",
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      width: "100%",
    },
  },

  menuOption: {
    zIndex: "100",
    top: "5px",
    position: "absolute",
    right: "5px",
    display: "flex",
    justifyContent: "end",
  },

  projectOption: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",

    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  projectOption__labelContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  labelContainer__label: {
    fontSize: "16px",
    fontFamily: "Lato, sans-serif",

    color: "rgba(12, 14, 41, 0.8)",
  },

  labelContainer__help: {
    height: "16px",
    width: "16px",

    display: "block",

    color: "rgba(12, 14, 41, 0.8)",

    transition: "color ease-in 0.2s",

    "&:hover": {
      color: "rgba(12, 14, 41, 1)",
    },
  },

  menuRight: {
    display: "flex",
    alignItems: "center",
  },

  menuLeft: {
    display: "flex",
    alignItems: "center",
  },

  titleTextStyle: {
    marginLeft: "20px",
  },

  titleSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  smallMenuItem: {
    display: "flex",
    paddingBottom: "1rem",
    justifyContent: "center",
    background: "#FFFFFF",
    alignItems: "center",
  },

  titleStyle: {
    paddingLeft: "10%",
    paddingRight: "10%",
    display: "flex",
    alignContent: "space-around",
    alignItems: "center",
    background: "#FFFFFF",
    justifyContent: "space-between",
  },

  activeFor: {
    color: "#696969",
    fontSize: "15px",
  },

  backIcon: {
    padding: "20px",
    cursor: "pointer",
  },

  hstyle: {
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "2.5rem",
    lineHeight: "48px",
    color: "#1D3557",
  },

  projectSettingsRow: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",
    marginBottom: "16px",
  },

  primaryIconButton: {
    height: "40px",
    padding: "0 16px",
    paddingLeft: "8px",

    border: "none",
    borderRadius: "4px",

    fontSize: "16px",
    color: "white",
    backgroundColor: "var(--color-primary)",

    display: "flex",
    gap: "8px",
    alignItems: "center",

    transition: "all 0.2s ease-in-out",

    "&:hover": {
      backgroundColor: "#a77d4f",
      color: "white",
      cursor: "pointer",
    },
  },

  secondaryIconButton: {
    height: "40px",
    padding: "0 16px",
    paddingLeft: "8px",

    border: "1px solid #DCDCDC",
    borderRadius: "4px",

    fontSize: "16px",
    color: "#0C0E29",
    backgroundColor: "white",

    display: "flex",
    gap: "8px",
    alignItems: "center",

    transition: "all 0.2s ease-in-out",

    "&:hover": {
      backgroundColor: "#F8F8F8",
      borderColor: "var(--color-primary)",
      cursor: "pointer",
    },
  },

  iconButton__icon: {
    height: "20px",
    width: "20px",
    strokeWidth: "2px",

    display: "block",
  },

  errorContainer: {
    width: "100%",
    backgroundColor: "#FDF3F3",

    border: "1px solid #FBE5E5",
    borderRadius: "6px",

    marginBottom: "16px",
    padding: "12px",
  },

  errorMessage: {
    fontSize: "16px",
    color: "#D84949",
  },
}));